<div class="sub-container">
    <h2 class="headline-highlight">Edit Payment Method</h2>

<div class="hosted-payment-edit-container">
  
  <div class="iframe-placeholder" style="position: relative; margin-bottom:30px; width: 40%; height: 900px; border: 1px solid #ddd; border-radius: 4px; background-color: #f8f9fa;">
    <div *ngIf="loading" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
      <p>Loading Authorize.Net Edit Form...</p>
    </div>
    <div *ngIf="systemError" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: red;">
      <p>Error loading edit form. Please try again.</p>
    </div>
    <p class="credit-card">Edit Credit Card</p>
    <iframe
      #editPaymentIframe
      id="add_payment" style="width: 100%; height: 90%; border: none; visibility: hidden;"
      name="authorizeNetIframe"
    ></iframe>
  </div>

  <form #sendTokenForm id="send_token_edit" action="" method="post" target="authorizeNetIframe" style="display: none;">
    <input type="hidden" name="token" value="" #tokenInput />
    <input type="hidden" name="paymentProfileId" value="" #paymentProfileIdInput /> <input type="hidden" name="hostedPaymentIFrameCommunicatorUrl" value="" #communicatorUrlInput />
  </form>
</div>
</div>
